var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var FacilitiesComponent = /** @class */ (function (_super) {
    __extends(FacilitiesComponent, _super);
    function FacilitiesComponent(injector, translateService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.translateService = translateService;
        _this.reasons = [
            {
                title: 'Locuri individuale de parcare',
                content: "\n        Nu \u00EE\u021Bi vei mai pune niciodat\u0103 problema dac\u0103 ai unde s\u0103 parchezi sau nu.\n        Conceptul Dream Residence pune la dispozi\u021Bie at\u00E2t parc\u0103ri subterane, c\u00E2t \u0219i supraterane,\n        pentru tine \u0219i musafirii t\u0103i.\n      ",
                image: {
                    url: '/assets/icons/facilities/parcare.svg'
                }
            },
            {
                title: 'Spații verzi',
                content: "\n        Ne asigur\u0103m de bun\u0103starea reziden\u021Bilor no\u0219tri. Vei beneficia de spa\u021Bii comune verzi,\n        unde te po\u021Bi recrea. Natura te va bucura \u00EEn fiecare anotimp, \u00EEn timp ce tu ai la\n        dispozi\u021Bie beneficiile unui stil de via\u021B\u0103 modern, dar \u0219i lini\u0219tea \u0219i frumuse\u021Bea naturii.\n      ",
                image: {
                    url: '/assets/icons/facilities/spatii-verzi.svg'
                }
            },
            {
                title: 'Dotări locuință',
                content: "\n        Apartamentul t\u0103u se va preda complet finisat (gresie, faian\u021Ba, parchet, u\u0219i interioare,\n          obiecte sanitare \u00EEn baie, central\u0103 termic\u0103, radiatoare, prize, \u00EEntrerup\u0103toare \u0219i racordat\n          la toate utilit\u0103\u021Bile (gaze naturale, energie electric\u0103, ap\u0103 curent\u0103, canalizare)\n      ",
                image: {
                    url: '/assets/icons/facilities/dotari.svg'
                }
            },
            {
                title: 'Facilități la îndemână',
                content: "\n        Ne-am g\u00E2ndit c\u0103 o locuin\u021B\u0103 ideal\u0103 \u00EEn visul fiec\u0103ruia ar pune la dispozi\u021Bie\n        toate cele necesare pentru un trai modern.  E\u0219ti aproape de marile centre comerciale din zon\u0103\n        (Mega Image, Liberty Mall, Kaufland, Cora, Carrefour Vulcan). Ajungi repede \u00EEn centrul ora\u0219ului\n        (numai 4 km pana la Unirii). \u00CEn proximitatea apartamentelor se afl\u0103 \u0219coli, gr\u0103dini\u021Be, dar \u0219i un\n        parc \u00EEn imediata vecin\u0103tate.\n      ",
                image: {
                    url: '/assets/icons/facilities/facilitati.svg'
                }
            },
            {
                title: 'Tu îți personalizezi locuința',
                content: "\n        Casa este sanctuarul t\u0103u, iar noi \u0219tim asta. De aceea, te ajut\u0103m\n        s\u0103-\u021Bi personalizezi locuin\u021Ba prin alegerea finisajelor pe care \u021Bi le\n        punem la dispozi\u021Bie. Nu \u00EE\u021Bi face griji, avem o palet\u0103 larg\u0103. Suntem\n        siguri c\u0103 vei g\u0103si ceva pe gustul t\u0103u.\n        Noi d\u0103m via\u021B\u0103 visului t\u0103u, r\u0103m\u00E2ne la latitudinea ta modul \u00EEn care\n        scrii povestea casei tale.\n      ",
                image: {
                    url: '/assets/icons/facilities/personalizare.svg'
                }
            },
            {
                title: 'Siguranța ta, prioritatea noastră',
                content: "\n        Nimic nu este mai presus pentru noi dec\u00E2t confortul \u0219i siguran\u021Ba ta \u0219i a familiei tale. De aceea,\n        ne-am luat angajamentul s\u0103 dot\u0103m fiecare bloc pe care \u00EEl ad\u0103ug\u0103m proiectului nostru cu sisteme\n        de supraveghere video, at\u00E2t \u00EEn spa\u021Biile comune c\u00E2t \u0219i \u00EEn afar\u0103 . Ba mai mult, fiecare apartament va\n        beneficia de videointerfon. Toate acestea fac parte din conceptul Dream, o comunitate sigur\u0103,\n        cald\u0103, fericit\u0103, un loc ideal pentru tine \u0219i pentru familia ta. Bun venit acas\u0103, \u00EEn Cartierul Nou Rahova !\n      ",
                image: {
                    url: '/assets/icons/facilities/siguranta.svg'
                }
            }
        ];
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        return _this;
    }
    FacilitiesComponent.prototype.ngOnInit = function () {
        this.meta.addTags([
            { name: 'robots', content: 'noindex' }
        ]);
        this.setTitle('Facilitățile proiectului Dream Residence');
    };
    return FacilitiesComponent;
}(SeoAwareBaseComponent));
export { FacilitiesComponent };



// WEBPACK FOOTER //
// ./src/app/about-us/facilities.component.ts.pre-build-optimizer.js